<template>
    <div class="biz-new-econtract">
        <modal class="house-list" :display="modalStatus.houseList" @modalStatus="closeModal()" >
            <h1>
                選擇房源
            </h1>
            <div class="group">
                <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
                <rent-select class="select-scroll" refName="member" selectMsg="所有業務" :isEdit="contractData.tenantNumber?true:false" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li :data-id="null" :data-name="null">所有業務</li>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="content">
                <div class="table-title">
                    <span class="name">房源名稱</span>
                    <span class="address">房源地址</span>
                    <span class="agent">業務</span>
                    <span class="rent">租金</span>
                </div>
                <div class="table-body">
                    <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                        <li v-for="(item, index) in filterByWord" :key="index">
                            <default-radio v-model="selectedHouseInfo.houseCid" :isPropChecked="false" :val="item.houseCid"></default-radio>
                            <span class="name">{{item.houseName}}</span>
                            <span class="address">{{item.address}}</span>
                            <span class="agent">{{item.agentName}}</span>
                            <span class="rent">{{toCurrency(item.rent)}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setHouseInfo(), closeModal()">確認</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="default-wrap contract-state">
            <div class="contract-state-wrap">
                <span class="progress">
                    <span class="progress-bar">
                        <span class="progress-status" :class="{'active': contractState == 1}">
                            1 合約資料
                        </span>
                        <span class="progress-hr"></span>
                        <span class="progress-status" :class="{'active': contractState == 2}">
                            2 收租設定
                        </span>
                        <span class="progress-hr"></span>
                        <span class="progress-status" :class="{'active': contractState == 3}">
                            3 業務簽名
                        </span>
                        <span class="progress-hr"></span>
                        <span class="progress-status" :class="{'active': contractState == 4}">
                            4 通知租客
                        </span>
                    </span>
                    
                </span>
            </div>
            <div class="btn-group">
                <button v-if="contractState == 4" class="default-button next" @click="toBookingMgt(), $analyticsBiz.logEvent('回租約管理', { screen_name: '回租約管理'})" :disabled="isDisabled">查看進度</button>
                <!-- <button v-if="contractState == 2" class="border-button save" @click="saveContract(1), $analyticsBiz.logEvent('儲存合約資料', { screen_name: '儲存合約資料'})">儲存</button> -->
                <button v-if="contractState == 1" class="default-button next" @click="saveContract(), $analyticsBiz.logEvent('下一步：繳費設定', { screen_name: '下一步：繳費設定'})" :disabled="isDisabled">下一步：繳費設定</button>
                <button v-else-if="contractState == 2" class="default-button next" @click="saveDepositAndBill(), $analyticsBiz.logEvent('下一步：業務簽名', { screen_name: '下一步：業務簽名'})" :disabled="isDisabled">下一步：業務簽名</button>
                <button v-else-if="contractState == 3" class="default-button next" @click="notifyTenant(), $analyticsBiz.logEvent('下一步：通知租客', { screen_name: '下一步：通知租客'})" :disabled="isDisabled">下一步：通知租客</button>
            </div>
        </div>
        <div class="must-fill-alarm" v-if="contractState == 1">
            <div class="title">
                注意事項：
            </div>
            <div class="list">
                下方欄位所輸入的資料將會帶入電子合約當中，請填入真實資料。
            </div>
        </div> 
        <div class="must-fill-alarm" v-if="contractState == 2">
            <div class="title">
                注意事項：
            </div>
            <div class="list">
                設定合約成立之前，房客須支付的押金金額及其他費用，如無其他費用可以不用新增。<br>可調整押金，最高不得超過兩個月租金總額。
            </div>
        </div> 
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                租客資料
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="tanant-info">
                    <div class="tanant-info-wrap">
                        <div class="phone">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租客手機
                                </div>
                                <span v-show="error.contractData.tenantPhone" class="error-with-title">{{error.contractData.tenantPhone}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.contractData.tenantPhone}" type="text" v-model="contractData.tenantPhone" placeholder="請輸入手機號碼">
                            </div>
                        </div>
                        <div class="tanant-name">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租客姓名
                                </div>
                                <span v-show="error.contractData.tenantName" class="error-with-title">{{error.contractData.tenantName}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.contractData.tenantName}" type="text" v-model="contractData.tenantName" placeholder="請輸入租客姓名">
                            </div>
                        </div>
                        <div class="identification">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    身分證字號/居留證號
                                </div>
                                <span v-show="error.contractData.tenantIdNumber" class="error-with-title">{{error.contractData.tenantIdNumber}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.contractData.tenantIdNumber}" type="text" v-model="contractData.tenantIdNumber" placeholder="請輸入內容">
                            </div>
                        </div>
                        <div class="upload-id">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    上傳身分證/居留證圖片(正反)
                                </div>
                                <span v-show="error.contractData.tenantIdCard" class="error-with-title">{{error.contractData.tenantIdCard}}</span>
                            </label>
                            <div class="input-arear">
                                <div class="upload-id-wrap">
                                    <div v-if="identification.font.length > 0"  class="list-upload font-side">
                                        <img  class="cancel" @click.prevent="identification.font = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                        <div  class="preview">
                                            <img :src="identification.font[0].blob" />
                                        </div>
                                    </div>
                                    <div v-else class="list-upload font-side">
                                        <file-upload
                                        v-if="identification.font.length == 0"
                                        class="upload-btn"
                                        post-action="/upload/post"
                                        input-id="font"
                                        :size="1024 * 5"
                                        :maximum="1"
                                        :multiple="true"
                                        v-model="identification.font"
                                        @input-filter="inputFilter"
                                        ref="font">
                                        <img v-if="identification.font.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                        正面
                                        </file-upload>
                                    </div>
                                    <div v-if="identification.back.length > 0" class="list-upload back-side">
                                        <img class="cancel" @click.prevent="identification.back = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                        <div class="preview">
                                            <img  :src="identification.back[0].blob" />
                                        </div>
                                        <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    </div>
                                    <div v-else class="list-upload back-side">
                                        <file-upload
                                        v-if="identification.back.length == 0"
                                        class="upload-btn"
                                        post-action="/upload/post"
                                        input-id="back"
                                        :size="1024 * 5"
                                        :maximum="1"
                                        :multiple="true"
                                        v-model="identification.back"
                                        @input-filter="inputFilter"
                                        ref="back">
                                            <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                            反面
                                        </file-upload>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                選擇房源
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="house-select">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            選擇房源
                        </div>
                        <span v-show="error.serviceFeeRateErr" class="error-with-title">{{error.serviceFeeRateErr}}</span>
                    </label>
                    <div class="input-arear">
                        <div v-if="selectedHouseInfo.houseName" class="house-info-wrap">
                            <default-radio :isPropChecked="true"></default-radio>
                            <div class="house-info">
                                <div class="name">{{selectedHouseInfo.houseName}}</div>
                                <div class="address">{{selectedHouseInfo.address}}</div>
                                <div class="rent">租金：${{selectedHouseInfo.rent}}</div>
                            </div>
                            <button  class="border-button" @click="choseHouse(), $analyticsBiz.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇其他房源</button>
                        </div>
                        <button v-else class="border-button chose-house" @click="choseHouse(), $analyticsBiz.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇房源</button>
                        <button v-if="selectedHouseInfo.houseName" class="border-button-gray edit-house" @click="editHouse()">編輯房源</button>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                合約資料
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="contract-info">
                    <div class="contract-info-wrap">
                        <div class="three-part move-in-date">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租約起訖日
                                </div>
                                <span v-show="error.contractData.periodDate" class="error-with-title">{{error.contractData.periodDate}}</span>
                            </label>
                            <div class="input-arear">
                                <date-picker v-model="datePeriod.contractPeriod" :class="{'active': contractData.contractBeginTime != null, 'error': error.contractData.periodDate}" placeholder="2020.05.06-2021.05.06" format="YYYY-MM-DD" valueType="format" :disabled-date="notBeforeThisday" rangeSeparator="-" range  ></date-picker>
                            </div>
                        </div>
                        <div class="three-part desposit">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    入住人數
                                </div>
                                <span v-show="error.contractData.tenantNumber" class="error-with-title">{{error.contractData.tenantNumber}}</span>
                            </label>
                            <div class="input-arear">
                                <rent-select :class="{error: error.contractData.tenantNumber}" class="select-scroll" refName="tenantNumber" :selectMsg="contractData.tenantNumber?contractData.tenantNumber+'個人':'請選擇入住人數'" :isEdit="contractData.tenantNumber?true:false" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="n in 100" :key="n" :data-id="n">
                                            {{n}} 個人
                                        </li>
                                    </ul>
                                </rent-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 2">
            <div class="toogle-title" slot="toogle-title">
                押金設定
            </div>
            <div class="toogle-body deposit-setting" slot="toogle-body">
                <div class="deposit-alarm">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    押金最高不得超過二個月租金之總額
                </div>
                <div class="bill-pay-day">
                    待您簽名後，房客須在72小時內完成付款
                </div>
                <div class="deposit">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            押金
                        </div>
                        <span v-show="error.depositAndBill.deposit" class="error-with-title">{{error.depositAndBill.deposit}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.depositAndBill.deposit}" type="text" v-model.number="depositAndBill.deposit" placeholder="請輸入押金">
                    </div>
                </div>
            </div>
        </toogle-block>
        <check-box-block v-if="contractState == 2" v-model="status.isBill" title="新增其他費用（非必填）">
            <div class="check-box-block-sub-title" slot="check-box-block-sub-title">
                新增帳單
            </div>
            <div class="check-box-block-body bill-setting" slot="check-box-block-body">
                <div class="bill-pay-day">
                    待您簽名後，房客須在72小時內完成付款
                </div>
                <div class="bill-setting-wrap">
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                帳單名稱
                            </div>
                            <span v-show="error.depositAndBill.billName" class="error-with-title">{{error.depositAndBill.billName}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.billName}" type="text" v-model="depositAndBill.billName" placeholder="請輸入帳單名稱">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                自訂計費期間
                            </div>
                            <span v-show="error.depositAndBill.periodDate" class="error-with-title">{{error.depositAndBill.periodDate}}</span>
                        </label>
                        <div class="input-arear">
                            <date-picker v-model="datePeriod.billPeriod" :class="{'active': datePeriod.billPeriod[0] != null, 'error': error.depositAndBill.periodDate}" placeholder="2020.05.06-2021.05.06" format="YYYY-MM-DD" valueType="format"  rangeSeparator="-" range  ></date-picker>
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                租金
                            </div>
                            <span v-show="error.depositAndBill.rent" class="error-with-title">{{error.depositAndBill.rent}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.rent}" type="text" v-model="depositAndBill.rent" placeholder="請輸入租金">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                水費
                            </div>
                            <span v-show="error.depositAndBill.waterBill" class="error-with-title">{{error.depositAndBill.waterBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.waterBill}" type="text" v-model="depositAndBill.waterBill" placeholder="請輸入水費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                電費
                            </div>
                            <span v-show="error.depositAndBill.electricityBill" class="error-with-title">{{error.depositAndBill.electricityBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.electricityBill}" type="text" v-model="depositAndBill.electricityBill" placeholder="請輸入電費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                瓦斯費
                            </div>
                            <span v-show="error.depositAndBill.gasBill" class="error-with-title">{{error.depositAndBill.gasBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.gasBill}" type="text" v-model="depositAndBill.gasBill" placeholder="請輸入瓦斯費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                網路費
                            </div>
                            <span v-show="error.depositAndBill.internetBill" class="error-with-title">{{error.depositAndBill.internetBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.internetBill}" type="text" v-model="depositAndBill.internetBill" placeholder="請輸入網路費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                有線電視
                            </div>
                            <span v-show="error.depositAndBill.tvBill" class="error-with-title">{{error.depositAndBill.tvBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.tvBill}" type="text" v-model="depositAndBill.tvBill" placeholder="請輸入有線電視費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                清潔費
                            </div>
                            <span v-show="error.depositAndBill.cleaningBill" class="error-with-title">{{error.depositAndBill.cleaningBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.cleaningBill}" type="text" v-model="depositAndBill.cleaningBill" placeholder="請輸入清潔費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                停車費
                            </div>
                            <span v-show="error.depositAndBill.parkingBill" class="error-with-title">{{error.depositAndBill.parkingBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.parkingBill}" type="text" v-model="depositAndBill.parkingBill" placeholder="請輸入停車費">
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                管理費
                            </div>
                            <span v-show="error.depositAndBill.managementBill" class="error-with-title">{{error.depositAndBill.managementBill}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.depositAndBill.managementBill}" type="text" v-model="depositAndBill.managementBill" placeholder="請輸入管理費">
                        </div>
                    </div>
                </div>
            </div>
        </check-box-block>
        <toogle-block v-if="contractState == 3">
            <div class="toogle-title" slot="toogle-title">
            確認合約後簽名
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="sign-contract">
                    <div class="view-contract" @click="signContract()">
                        查看合約
                    </div>
                    <img v-if="isSigned" src="@/assets/img/icon/success_done.svg" alt="">
                </div>
            </div>
        </toogle-block>
        <div v-if="contractState == 4" class="default-wrap notify">
            <img class="success" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
            <div class="title">
                已通知租客確認
            </div>
            <div class="description">
                我們已發簡訊通知租客，您可以下載 App 追蹤進度，我們也會發送推播，通知您租客的簽約進度。
            </div>
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
// import DatePicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import DefaultRadio from '@/components/widge/DefaultRadio.vue';
import FileUpload from 'vue-upload-component';
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import checkBoxBlock from '@/components/bussiness/widges/tools/checkBoxBlock.vue';
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import Modal from '@/components/widge/Modal.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'
const today = new Date();
today.setHours(0, 0, 0, 0);
// console.log(today)
export default {
    data () {
        return {
            modalHeight: (window.innerHeight-400) + 'px',
            componentKey: 0,
            contractData: {},
            depositAndBill: {
                nonBookingContractCid: null,
                deposit: null,
                billName: null,
                periodDate: null,
                rent:  0,
                waterBill:  0,
                electricityBill: 0,
                parkingBill:  0,
                managementBill: 0,
                internetBill: 0,
                tvBill: 0,
                cleaningBill: 0,
                gasBill: 0
            },
            identification: {},
            paperContract: [],
            paperContractType: null,
            uploadLimit: 100,
            isDefault: false,
            datePeriod: {},
            filter: {
                word: null,
                agent: null
            },
            error: {
                contractData: {
                    tenantName : null,
                    tenantPhone : null,
                    tenantIdNumber : null,
                    periodDate : null,
                    tenantNumber : null,
                    tenantIdCard : null,
                },
                depositAndBill: {
                    nonBookingContractCid: null,
                    deposit: null,
                    billName: null,
                    periodDate: null,
                    rent:  null,
                    waterBill:  null,
                    electricityBill: null,
                    parkingBill:  null,
                    managementBill: null,
                    internetBill: null,
                    tvBill: null,
                    cleaningBill: null,
                    gasBill: null
                }
            },
            status: {
                isBill: false,
            },
            isDefault: false,
            modalStatus: {
                houseList: false
            },
            selectedHouseInfo: {},
            isDisabled: false
        }
    },
    mounted() {
        this.$store.dispatch('getBizGetAvailableHouse')
        .then(()=>{
            if(this.econtractSelectedHouse.houseCid != null){
                this.setHouseInfo()
            }
        })
    },
    destroyed() {
        // if( this.contractState == 4 ){
        //     this.$store.dispatch('bizSetNewEContractDefault')
        // }
    },
    watch: {
        $route: {
            handler: function (val) {
                if( this.contractState == 4 ){
                    this.$store.dispatch('bizSetNewEContractDefault')
                }
            },
            immediate: true,
            deep: true
        },
        contractData: {
            handler: function (newValue, oldValue) {
                console.log(newValue)
                let phoneReg = /^09[0-9]{8}$/
                // let numerical = /^[0-9]*$/
                if(newValue.tenantPhone){
                    if( phoneReg.test(newValue.tenantPhone) ){
                        this.error.contractData.tenantPhone = null
                    }else{
                        this.error.contractData.tenantPhone = '格式不符'
                    }
                }
  
                if(newValue.tenantName){
                    this.error.contractData.tenantName = null
                }
              
                if(newValue.tenantIdNumber){
                    if(newValue.tenantIdNumber.length === 10){
                        this.error.contractData.tenantIdNumber = null
                    }else{
                        this.error.contractData.tenantIdNumber = '身分證格式錯誤'
                    }
                }
   
                if(newValue.contractBeginTime){
                    this.error.contractData.periodDate = null
                }

               if(newValue.contractEndTime && new Date(newValue.contractEndTime) < today){
                    this.error.contractData.periodDate = '租約訖日不可早於今日'
                }else if(newValue.contractEndTime){
                    this.error.contractData.periodDate = null
                }
        
               if(newValue.tenantNumber){
                    this.error.contractData.tenantNumber = null
                }
              
                this.$store.dispatch('bizSetNewEContractData', newValue)
            },
            deep:true
        },
        identification: {
            handler: function (val) {
                if(val.back.length && val.font.length){
                    this.error.contractData.tenantIdCard = null
                }
            },
            deep:true
        },
        depositAndBill: {
            handler: function (val) {
                console.log(val.deposit)
                if(val.billName){
                    this.error.depositAndBill.billName = null
                }
                if(val.deposit > this.selectedHouseInfo.rent*2){
                    this.error.depositAndBill.deposit = '押金最高不得超過二個月租金之總額'
                }else if(val.deposit){
                    this.error.depositAndBill.deposit = null
                }
                if(val.rent){
                    if(this.checkIsNum(val.rent)){
                        this.error.depositAndBill.rent = null
                    }else{
                        this.error.depositAndBill.rent = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.rent = null
                }
                if(val.gasBill) {
                    if(this.checkIsNum(val.gasBill)){
                        this.error.depositAndBill.gasBill = null
                    }else{
                        this.error.depositAndBill.gasBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.gasBill = null
                }
                if(val.tvBill) {
                    if(this.checkIsNum(val.tvBill)){
                        this.error.depositAndBill.tvBill = null
                    }else{
                        this.error.depositAndBill.tvBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.tvBill = null
                }
                if(val.waterBill) {
                    if(this.checkIsNum(val.waterBill)){
                        this.error.depositAndBill.waterBill = null
                    }else{
                        this.error.depositAndBill.waterBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.waterBill = null
                }
                if(val.parkingBill) {
                    if(this.checkIsNum(val.parkingBill)){
                        this.error.depositAndBill.parkingBill = null
                    }else{
                        this.error.depositAndBill.parkingBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.parkingBill = null
                }
                if(val.electricityBill) {
                    if(this.checkIsNum(val.electricityBill)){
                        this.error.depositAndBill.electricityBill = null
                    }else{
                        this.error.depositAndBill.electricityBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.electricityBill = null
                }
                if(val.internetBill) {
                    if(this.checkIsNum(val.internetBill)){
                        this.error.depositAndBill.internetBill = null
                    }else{
                        this.error.depositAndBill.internetBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.internetBill = null
                }
                if(val.cleaningBill) {
                    if(this.checkIsNum(val.cleaningBill)){
                        this.error.depositAndBill.cleaningBill = null
                    }else{
                        this.error.depositAndBill.cleaningBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.cleaningBill = null
                }
                if(val.managementBill) {
                    if(this.checkIsNum(val.managementBill)){
                        this.error.depositAndBill.managementBill = null
                    }else{
                        this.error.depositAndBill.managementBill = '請填寫數字'
                    }
                }else{
                    this.error.depositAndBill.managementBill = null
                }
                
            },
            deep: true
        },
        contractState: function (val) {
            if(val == 2){
                this.depositAndBill.nonBookingContractCid = this.nonbookingContract.nonBookingContractCid
                this.depositAndBill.deposit = this.nonbookingContract.deposit
            }
        },
        'datePeriod.contractPeriod': function (newValue, oldValue){
            // console.log(newValue)
            this.contractData.contractBeginTime = newValue[0]
            this.contractData.contractEndTime = newValue[1]
        },
        'datePeriod.billPeriod': function (newValue, oldValue){
            // console.log(newValue)\
            if(newValue[0] && newValue[1]){
                this.error.depositAndBill.periodDate = null
            }
            this.depositAndBill.periodStartDate = newValue[0]
            this.depositAndBill.periodEndDate = newValue[1]
        },
        econtractData: {
            handler:  function (val) {
                console.log(val)
                this.contractData = val
            },
            immediate: true
        },
        econtractIdCard: {
            handler:  function (val) {
                console.log(val)
                this.identification = val
            },
            immediate: true
        },
        econtractDatePeriod: {
            handler:  function (val) {
                console.log(val)
                this.datePeriod = val
            },
            immediate: true
        },
        econtractSelectedHouse: {
            handler:  function (val) {
                console.log(val)
                this.selectedHouseInfo = val
            },
            immediate: true
        },
    },
    methods: {
        setFilterWord: function (value) {
            this.filter.word = value
        },
        getSelectId: function (value) {
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'tenantNumber' ){
                this.contractData.tenantNumber = targetId
            }else if( value.ref == 'member' ){
                this.filter.agent = value.name
            }
        },        
        choseHouse: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.modalStatus.houseList = true
        },
        setHouseInfo: function (data) {
            let house = null
            this.houseList.forEach(element => {
                console.log(element)
                if(element.houseCid === this.selectedHouseInfo.houseCid){
                    house =  element
                }
            });
            this.selectedHouseInfo = Object.assign({}, house)
            this.$store.dispatch('bizSetNewContractSelectedHouse', this.selectedHouseInfo)
            this.$store.dispatch('getBizGetContractPeriod', this.selectedHouseInfo.houseCid)
        },
        closeModal: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.modalStatus.houseList = false
            this.setFilterDefault()
        },
        setFilterDefault: function () {
            this.filter = {
                word: null,
                agent: null
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳JPG或PNG檔案',type: 'error'})
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        checkTwID: function (id){
            //建立字母分數陣列(A~Z)
            var city = new Array(
                1,10,19,28,37,46,55,64,39,73,82, 2,11,
                20,48,29,38,47,56,65,74,83,21, 3,12,30
            )
            id = id.toUpperCase();
            // 使用「正規表達式」檢驗格式
            if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
                return false;
            } else {
                //將字串分割為陣列(IE必需這麼做才不會出錯)
                id = id.split('');
                //計算總分
                var total = city[id[0].charCodeAt(0)-65];
                for(var i=1; i<=8; i++){
                    total += eval(id[i]) * (9 - i);
                }
                //補上檢查碼(最後一碼)
                total += eval(id[9]);
                //檢查比對碼(餘數應為0);
                return ((total%10 == 0 ));
            }
        },
        inputBackFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        signContract: function () {
            if(this.isSigned){
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': this.econtracId, 'mode': 'contract', 'type': 'econtract', 'status': 'view'}})
            }else{
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': this.econtracId, 'mode': 'contract', 'type': 'econtract'}})
            }
        },
        saveContract: function () {
            if(this.checkContractInfo()){
                this.isDisabled = true
                let formData = new FormData();
                formData.append('housesCid', this.selectedHouseInfo.houseCid);
                formData.append('tenantName', this.contractData.tenantName);
                formData.append('tenantPhone', this.contractData.tenantPhone);
                formData.append('tenantIdNumber', this.contractData.tenantIdNumber);
                formData.append('idFileFront', this.identification.font[0].file);
                formData.append('idFileBack', this.identification.back[0].file);
                formData.append('contractBeginTime', this.contractData.contractBeginTime);
                formData.append('contractEndTime', this.contractData.contractEndTime);
                formData.append('tenantNumber', this.contractData.tenantNumber);

                this.$store.dispatch('saveBizNewEContract', formData)
                .then( status =>{
                    if(status){
                        this.$store.dispatch('bizSetNewEContractStatus', 2)
                    }
                    this.isDisabled = false
                })
                .catch(()=>{
                    this.isDisabled = false
                })
            }
        },
        saveDepositAndBill: function () {
            if(this.checkDepositAndBill()){
                this.isDisabled = true
                let data  = this.depositAndBill
                this.$store.dispatch('saveBizNewEContractBill', data)
                .then(status=>{
                    if(status){
                        this.$store.dispatch('bizSetNewEContractStatus', 3)
                    }
                    this.isDisabled = false
                })
                .catch(()=>{
                    this.isDisabled = false
                })
            }
        },
        notifyTenant: function () {
            if(this.isSigned){
                this.isDisabled = true
                let data = {
                    nonBookingContractCid: this.nonbookingContract.nonBookingContractCid
                }
                this.$store.dispatch('bizECNotifyTanant', data)
                .then(status=>{
                    if(status){
                        this.$store.dispatch('bizSetNewEContractStatus', 4)
                    }
                    this.isDisabled = false
                })
                .catch(()=>{
                    this.isDisabled = false
                })
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '您尚未確認合約並簽名，無法儲存',type: 'error'})
            }
        },
        toBookingMgt: function () {
            // window.location.href = '/bussiness/mgtCategory/leaseMgt/?success=1&type=2#紙本確認中'
            this.$router.push({name: 'bizBookingMgtDefault', hash: '#待租客簽約'})
            this.$store.dispatch('bizSetNewEContractDefault')
            this.$store.dispatch('setAlarmStatus', {status: true,title: '成功新增電子合約',description: '飛豬管家已發送簡訊通知房客進行合約確認，您也可以主動通知房客',type: 'success'})
        },
        checkContractInfo: function () {
            if(!this.contractData.tenantPhone){
                this.error.contractData.tenantPhone = '請填寫租客手機'
            }
            if(!this.contractData.tenantName){
                this.error.contractData.tenantName = '請填寫租客姓名'
            }else{
                this.error.contractData.tenantName = null
            }

            if(!this.contractData.tenantIdNumber){
                this.error.contractData.tenantIdNumber = '請填寫身份字號'
            }
            if(!this.contractData.contractBeginTime){
                this.error.contractData.periodDate = '請填寫租約起訖日'
            }
            if(!this.contractData.tenantNumber){
                this.error.contractData.tenantNumber = '請填寫入住人數'
            }
            if(!this.identification.font.length){
                this.error.contractData.tenantIdCard = '請上傳身分證圖片'
            }
            if(!this.identification.back.length){
                this.error.contractData.tenantIdCard = '請上傳身分證圖片'
            }
            if(
                this.contractData.tenantName &&
                this.contractData.tenantPhone &&
                this.contractData.tenantIdNumber &&
                this.contractData.contractBeginTime &&
                this.contractData.contractEndTime &&
                this.contractData.tenantNumber &&
                this.error.contractData.tenantPhone == null  &&
                this.error.contractData.tenantIdNumber == null  &&
                this.error.contractData.periodDate == null &&
                this.error.contractData.tenantIdCard == null
            ){
                return true
            }else{
                return false
            }
        },
        checkDepositAndBill: function () {
            if(!this.depositAndBill.deposit){
                this.error.depositAndBill.deposit = '請輸入押金'
            }
            if(this.status.isBill){
                if(!this.depositAndBill.billName){
                    this.error.depositAndBill.billName = '請輸入帳單名稱'
                }
                if(!this.depositAndBill.periodStartDate || !this.depositAndBill.periodEndDate){
                    this.error.depositAndBill.periodDate = '請輸入計費期間'
                }

                if(
                    this.depositAndBill.deposit &&
                    this.depositAndBill.billName &&
                    this.depositAndBill.periodStartDate &&
                    this.depositAndBill.periodEndDate &&
                    !this.error.depositAndBill.deposit &&
                    !this.error.depositAndBill.billName &&
                    !this.error.depositAndBill.periodDate &&
                    !this.error.depositAndBill.rent &&
                    !this.error.depositAndBill.waterBill &&
                    !this.error.depositAndBill.electricityBill &&
                    !this.error.depositAndBill.parkingBill &&
                    !this.error.depositAndBill.managementBill &&
                    !this.error.depositAndBill.internetBill &&
                    !this.error.depositAndBill.tvBill &&
                    !this.error.depositAndBill.cleaningBill &&
                    !this.error.depositAndBill.gasBill
                ){
                    return true
                }else{
                    return false
                }
            }else{
                this.depositAndBill.billName = null,
                this.depositAndBill.periodStartDate = null,
                this.depositAndBill.periodEndDate = null,
                this.depositAndBill.rent =  0,
                this.depositAndBill.waterBill =  0,
                this.depositAndBill.electricityBill = 0,
                this.depositAndBill.parkingBill =  0,
                this.depositAndBill.managementBill = 0,
                this.depositAndBill.internetBill = 0,
                this.depositAndBill.tvBill = 0,
                this.depositAndBill.cleaningBill = 0,
                this.depositAndBill.gasBill = 0

                if(
                    this.depositAndBill.deposit &&
                    !this.error.depositAndBill.deposit 
                ){
                    return true
                }else{
                    return false
                }
            }
        },
        notBeforeThisday(date) {
            let moveInDate = this.selectedHouseInfo.moveInDate
            let contractPeriod = this.selectedHouseInfo.contractPeriod
            if(contractPeriod.length){
                for (let i = 0; i < contractPeriod.length; i++) {
                    const element = contractPeriod[i];
                    
                    if(element.contractBeginTime-86400000 < date &&  element.contractEndTime+86400000 > date || moveInDate > date){
                        return true
                    }
                }
            }else{
                return moveInDate > date
            }
        },
        editHouse(){
            if(this.selectedHouseInfo.houseStatus !== 2){
                this.$router.push({name: 'bizEditHouse', query: {'cid': this.selectedHouseInfo.houseCid,'type': 'econtract'}})
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error'})
            }
        },
    },
    computed:{
        // eContractHouseList: function () {
        //     return this.houseList.filter((houseItem) => {
        //         if( houseItem.complete && houseItem.status !== 2){
        //             return houseItem
        //         }
        //     });
        // },
        filterBySales: function () {
            return this.houseList.filter((item) => {
                if(this.filter.agent){
                    if(item.agentName == this.filter.agent ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterBySales.filter((item) => {
                if( this.filter.word ){
                    if( item.address.includes(this.filter.word)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        payBillDate(){
            let dateTime = new Date();
            dateTime = dateTime.setDate(dateTime.getDate()+3);
            dateTime=new Date(dateTime);
            return dateTime
        },
        ...mapGetters({
            houseList: 'GET_BIZ_ECONTRACT_AVAILABLE_HOUSE',
            contractState: 'GET_BIZ_ECONTRACT_STATUS',
            nonbookingContract: 'GET_BIZ_NONBOOKING_CONTRACT',
            econtracId: 'GET_BIZ_ECONTRACT_ID',
            isSigned: 'GET_BIZ_SIGNED_STATUS',
            econtractData: 'GET_BIZ_ECONTRACT_DATA',
            econtractIdCard: 'GET_BIZ_ECONTRACT_IDENTIFICATION',
            econtractDatePeriod: 'GET_BIZ_ECONTRACT_DATE_PERIOD',
            econtractSelectedHouse: 'GET_BIZ_ECONTRACT_SELECTED_HOUSE',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
        })
    },
    components: {
        RentSelect,
        DatePicker,
        FileUpload,
        toogleBlock,
        checkBoxBlock,
        borderTips,
        titleTips,
        RentSelectFilter,
        Modal,
        DefaultRadio,
        TableSearch
    }
}
</script>
<style lang="scss" scoped>
    .biz-new-econtract{
        position: relative;
        margin-bottom: 300px;
        .mx-datepicker{
            width: 324px;
            input{
                width: 100%;
                height: 44px;
                border-radius: 4px;
                border: solid 1px #f3f3f3;
                color: #a8a5a4;
                padding: 13px 16px;
                box-shadow: none;
                margin-bottom: 0px;
            }
            .mx-icon-calendar,
            .mx-icon-clear{
                right: 14px;
            }
        }
        .mx-datepicker:hover,
        .mx-datepicker.active{
            input{
                border: 1px solid #e0dfde !important;
                color: #e0dfde !important;
            }
            i{
                color: #e0dfde;
            }
        }
        .mx-datepicker.errorr{
            input{
                border: 1px solid #fc7171 !important;
            }
        }
        #modal.house-list{
            .modal-content{
                width: 900px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        display: flex;
                        font-size: 24px;
                        margin: auto;
                        margin-top: 32px;
                        margin-bottom: 32px;
                    }
                    .group{
                        display: flex;
                        margin-bottom: 12px;
                        .table-search{
                            width: 573px;
                            margin-right: 10px;
                        }
                        .biz-rent-select{
                            width: 216px;
                        }
                    }
                    .content{
                        width: 833px;
                        margin-bottom: 8px;
                        padding: 0px 32px;
                        .table-title{
                            padding: 20px 0;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                            .name{
                                width: 235px;
                                margin-left: 57px;
                                margin-right: 50px;
                            }
                            .address{
                                width: 265px;
                                margin-right: 50px;
                            }
                            .agent{
                                width: 50px;
                                margin-right: 50px;
                            }
                        }
                        .table-body{
                            ul{
                                height: 360px;
                                overflow-x: hidden;
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 20px 0;
                                    border-bottom: 1px solid #F1F5F4;
                                    .name{
                                        width: 235px;
                                        margin-left: 24px;
                                        margin-right: 50px;
                                    }
                                    .address{
                                        width: 265px;
                                        margin-right: 50px;
                                    }
                                    .agent{
                                        width: 50px;
                                        margin-right: 50px;
                                    }
                                }
                            }
                            ul::-webkit-scrollbar {
                                display: none;
                            }
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                    }
                }
            }
        }
        .contract-state{
            position: relative;
            display: flex;
            align-items: center;
            width: 1140px;
            height: 92px;
            margin-bottom: 20px;
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-status{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    background-color: #ffffff;
                    color: #a19d9c;
                    width: 124px;
                    height: 44px;
                    .order{
                        font-size: 12px;
                        margin-right: 4px;
                    }
                }
                .progress-status.active{
                    color: #3942b5;
                    border: solid 1px #3942b5;
                    background-color: rgba(57, 66, 181, 0.06);
                }
                .progress-hr{
                    width: 48px;
                    height: 1px;
                    background: #cacfcd;
                }
            }
            .btn-group{
                position: absolute;
                display: flex;
                right: 24px;
                .save{
                    width: 132px;
                    margin-right: 12px;
                }
                .next{
                    width: 200px;
                }
                .view-biz-new-econtract{
                    width: 200px;
                    height: 44px;
                    cursor: pointer;
                }
            }
        }
        .biz-rent-select{
            background: #fff;
        }
        .biz-rent-select.error{
            bottom: unset;
            left: unset;
        }
        .tanant-info{
            .tanant-info-wrap{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                >div{
                    width: 324px;
                    margin-right: 60px;
                    margin-bottom: 24px;
                    input{
                        width: 100%;
                        height: 44px;
                    }
                }
                >div:nth-child(3n){
                    margin-right: 0px;
                }
                .upload-id{
                    .upload-id-wrap{
                        display: flex;
                        .list-upload{
                            position: relative;
                            width: 124px;
                            height: 93px;
                            margin-right: 10px;
                            border-radius: 4px;
                            border: dashed 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            .upload-icon{
                                width: 24px;
                                height: 24px;
                                margin-bottom: 4px;
                            }
                            .cancel{
                                position: absolute;
                                cursor: pointer;
                                top: -14px;
                                right: -14px;
                            }
                            .preview{
                                width: 124px;
                                height: 93px;
                                display: flex;
                                align-items: center;
                                border-radius: 4px;
                                overflow: hidden;
                                >img{
                                    width: 100%;
                                }
                            }
                            .file-uploads{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    
                }
            }
            
        }
        .contract-info{
            .contract-info-wrap{
                display: flex;
                flex-wrap: wrap;
                .three-part{
                    width: 324px;
                    margin-right: 60px;
                    margin-bottom: 24px;
                    input{
                        width: 100%;
                    }
                }
                >div:nth-child(4n){
                    margin-right: 0px;
                }
                
                span.error{
                    bottom: unset;
                    left: unset;
                }
            }
        }
        .deposit-setting{
            .deposit-alarm{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                >img{
                    margin-right: 5px;
                }
            }
            .deposit{
                width: 324px;
            }
        }
        .bill-pay-day{
            position: relative;
            width: 1140px;
            left: -24px;
            background-color: #fff2f2;
            color: #fc7171;
            padding: 16px 25px 18px;
            margin-bottom: 24px;
            font-size: 16px;
            font-weight: 500;
            box-sizing: border-box;
        }
        .bill-setting{
            .bill-setting-wrap{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                >div{
                    width: 324px;
                    margin-right: 60px;
                    margin-bottom: 24px;
                    input{
                        width: 100%;
                        height: 44px;
                    }
                }
                >div:nth-child(3n){
                    margin-right: 0px;
                }
            }
        }
        .notify{
            position: relative;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-items: center;
            .success{
                width: 50px;
                margin-top: 30px;
                margin-bottom: 22px;
            }
            .title{
                display: flex;
                align-items: center;
                font-size: 24px;
                font-weight: 500;
                margin-bottom: 14px;
                img{
                    margin-right: 12px;
                }
            }
            .description{
                width: 368px;
                font-weight: 300;
                line-height: 1.7;
                margin-bottom: 20px;
            }
            .qr{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-bottom: 30px;
                img{
                    padding: 10px;
                    background: #fff;
                    margin-bottom: 12px;
                }
            }
        }
        .house-select{
            .chose-house{
                width: 324px;
            }
            .edit-house{
                width: 120px;
            }
            .house-info-wrap{
                position: relative;
                display: flex;
                align-items: center;
                width: 546px;
                height: 108px;
                border-radius: 4px;
                border: solid 1px #ff9275;
                background: #fff;
                padding: 16px 24px 16px 24px;
                box-sizing: border-box;
                margin-right: 12px;
                .dafault-checkbox{
                    margin-bottom: 0px;
                }
                .house-info{
                    margin-left: 22px;
                    >div{
                        margin-bottom: 6px;
                    }
                }
                >button{
                    position: absolute;
                    right: 40px;
                    height: 44px;
                    border: none;
                }
            }
            .input-arear{
                display: flex;
                align-items: center;
            }
        }
        .sign-contract{
            display: flex;
            align-items: center;
            .view-contract{
                width: 324px;
                height: 44px;
                border-radius: 4px;
                border: solid 1px #e0dfde;
                background-color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-right: 11px;
            }
            >img{
                width: 17px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/newContract/NewEContract.vue